import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-update-orgnaization',
  imports: [SharedModule],
  templateUrl: './update-orgnaization.component.html',
  styleUrl: './update-orgnaization.component.scss'
})
export class UpdateOrgnaizationComponent {
  orgForm!: FormGroup;
  @Input() orgId!: string;
  imageUrl: string = '';
  orgData: any = {}; // Initialize orgData to an empty object

  isInitialLoading: boolean = true; // Flag to track initial loading state

  constructor(private route: ActivatedRoute, private orgService: OrganizationService, private fb: FormBuilder,
    private messageService: MessageService
  ) {

  }

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  ngOnInit() {
    this.orgForm = this.fb.group({
      Name: ['', Validators.required],          // Name missing required in your code! 
      Type: ['', Validators.required],
      Address: [''],
      City: [''],
      State: [''],
      Country: [''],
      Postal_code: [''],
      Contact_number: [''],
      Email: ['', [Validators.required, Validators.email]], // Email needs BOTH required + email
      Website: [''],
      Establishment_year: [''],
      Registration_number: [''],
      Accreditation: [''],
      Institution_code: [''],
      Status: ['', Validators.required],
      Bot_client_id: ['']
    });


    this.route.params.subscribe(params => {
      this.orgId = params['id'];
      console.log('🚀 Organization ID:', this.orgId);
    });

    this.getOrgDetails();
  }

  getOrgDetails() {
    this.orgService.getOrganizationById({ organization_id: this.orgId }).subscribe({
      next: (data) => {
        this.orgData = data;

        this.isInitialLoading = false; // Set loading to false after data is fetched
        this.orgForm.patchValue({
          Name: data.name,
          Type: data.type,
          Address: data.address,
          City: data.city,
          State: data.state,
          Country: data.country,
          Postal_code: data.postal_code,
          Contact_number: data.contact_number,
          Email: data.email,
          Website: data.website,
          Establishment_year: data.establishment_year,
          Registration_number: data.registration_number,
          Accreditation: data.accreditation,
          Institution_code: data.institution_code,
          Status: data.status,
          Bot_client_id: data.bot_client_id
        });

      },
      error: (err) => {
        this.isInitialLoading = false; // Set loading to false on error as well
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch organization details. Please try again later.',
          life: 3000 // Optional: duration in milliseconds for the message to be visible
        });
      }
    });
  }

  getOrgKeys(data: any): string[] {
    return Object.keys(data);
  }

  isUpdating: boolean = false; // Flag to track if the form is being updated
  updateOrgDetails() {
    if (this.orgForm.invalid) {
      this.orgForm.markAllAsTouched(); // very important to highlight all fields
      return;
    }
    if (this.orgForm.invalid) {
      console.warn('Form is invalid:', this.orgForm.errors);
      return;
    }

    const payload = this.orgForm.value;
    const updatedData = {
      organization_id: this.orgId,
      name: payload.Name,
      type: payload.Type,
      address: payload.Address,
      city: payload.City,
      state: payload.State,
      country: payload.Country,
      postal_code: payload.Postal_code,
      contact_number: payload.Contact_number,
      email: payload.Email,
      website: payload.Website,
      establishment_year: payload.Establishment_year,
      registration_number: payload.Registration_number,
      accreditation: payload.Accreditation,
      institution_code: payload.Institution_code,
      status: payload.Status,
      bot_client_id: payload.Bot_client_id
    };

    this.isUpdating = true; // Set loading to true when starting the update

    this.orgService.updateOrganization(updatedData).subscribe({
      next: (res) => {
        console.log('✅ API response:', res);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Organization updated successfully!',
          life: 3000 // Optional: duration in milliseconds for the message to be visible
        });

        this.isUpdating = false; // Set loading to false after the update is complete
      },
      error: (err) => {
        this.isUpdating = false; // Set loading to false on error as well
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update organization. Please try again later.',
          life: 3000 // Optional: duration in milliseconds for the message to be visible
        });
      }
    });
  }

  handleFileChange(event: any): void {
    // const file = event.target.files[0];
    // if (file) {
    //   const formData = new FormData();
    //   formData.append('file', file);

    // this.http.post<UploadResponse>(environment.upload, formData).subscribe({
    //  next: (res) => {
    //    console.log('✅ Image uploaded!', res);
    //    const url = res.imageUrl.startsWith('http')
    //     ? res.imageUrl
    //    : `${environment.upload}${res.imageUrl}`;

    //   this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    //  this.orgForm.patchValue({ logo: res.imageUrl });
    //   this.orgData.logo = res.imageUrl;
    //  },
    //  error: (err) => console.error('❌ Image upload failed', err)
    //   this.http.post<UploadResponse>(environment.upload, formData).subscribe({
    //     next: (res) => {
    //       console.log('✅ Image uploaded!', res);
    //       const url = res.imageUrl.startsWith('http')
    //         ? res.imageUrl
    //         : `${environment.upload}${res.imageUrl}`;
    //       this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    //       this.orgForm.patchValue({ logo: res.imageUrl });
    //       this.orgData.logo = res.imageUrl;
    //     },
    //     error: (err) => {
    //       console.error('❌ Image upload failed', err);
    //       // Add more detailed logging here
    //       if (err.status === 502) {
    //         alert('Server error while uploading the image. Please try again later.');
    //       } else {
    //         alert('An unexpected error occurred. Please check the console for details.');
    //       }
    //     }
    //   });
    // }
  }

  formatFieldName(fieldName: string): string {
    return fieldName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
}
